import HttpRequest from './httpRequest'

export default class PaymentProvider extends HttpRequest {
  createCharge (attributes) {
    return this.create('/kpayment-gateway/charge', attributes)
  }

  createOrder(attributes) {
    return this.create('/kpayment-gateway/createOrder', attributes)
  }

  createCustomer(params) {
    return this.create('/kpayment-gateway/create-customer', params)
  }

  insertNewCard(id, params) {
    return this.create(`/kpayment-gateway/insert-card/${id}`, params)
  }

  inquiryTransaction(id) {
    return this.create('/kpayment-gateway/inquiry-transaction', { id })
  }
}
